<template>
  <div>
    <news-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :showback="showback"
      :logo="logo"
    ></news-header>
    <news-content :news="newsInfo"></news-content>
    <news-footer :bottom="bottom" :bottomInfo="contactInfo"></news-footer>
  </div>
</template>

<script>
import NewsHeader from "@/components/mobile/Header";
import NewsContent from "@/components/mobile/NewsContent";
import NewsFooter from "@/components/mobile/Footer";
export default {
  name: "NewsDetail",
  data() {
    return {
      topStyle: "padding-bottom: 20%",
      actIndex: 4,
      imgList: [],
      showback: true,
      bottom: {},
      logo: "",
      contactInfo: {},
      newsInfo: {},
      newsId: -1,
    };
  },
  components: {
    NewsHeader,
    NewsContent,
    NewsFooter,
  },
  watch: {
    $route() {
      this.newsId = this.$route.params.id;
      if (!this.newsId) return;
      this.getPageData();
    },
  },
  created() {
    this.newsId = this.$route.params.id;
    this.getPageData();
    this.getNewDetail();
    this.getHeaderImage();
    
  },
  mounted() {
    // if(this._isMobile()) {
    //     this.$router.replace('/m_NewsDetail/');
    // }else{
    //     this.$router.replace('/NewsDetail');
    // }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    getPageData() {
      // console.log(this.newsId);
      var id = this.newsId;
      if (/^\d{1,}t$/.test(id)) {
        this.$http.get(
          "home/index/getTeam",
          { id: id.substr(0, id.length - 1) },
          (res) => {
            // console.log(res.data)
            this.bottom = res.data.bottom[0];
            this.logo = this.bottom.logo;
            this.contactInfo = res.data.contact[0];
            this.newsInfo = res.data.teaminfo;
            // this.xg_news = res.data.xg_news
            // this.hy_news = res.data.hy_news
            // this.productType = res.data.type
            // this.bottomNews = res.data.b_news
            // this.prev = res.data.prev
            // this.next = res.data.next
            this.$nextTick(() => {});
          }
        );
      } else {
        this.$http.get("home/index/getNews", { id: this.newsId }, (res) => {
          // console.log(res.data)
          this.bottom = res.data.bottom[0];
          this.logo = this.bottom.logo;
          this.contactInfo = res.data.contact[0];
          // this.newsInfo = res.data.newsinfo
          this.$nextTick(() => {});
        });
      }
    },
    getNewDetail() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/new_detail",
        { id: this.newsId },
        (res) => {
          if (res.code == 1) {
            this.newsInfo = res.data.newsinfo;
            this.xg_news = res.data.xg_news;
            this.hy_news = res.data.hy_news;
          }
        }
      );
    },
    getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        { type_two: this.actIndex },
        (res) => {
          if (res.code == 1) {
            this.topStyle = "background-image:url('" + res.data.phone_image + "')";
          }
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/mobile/NewsDetail.vue